"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Message = exports.QueryMessageCount = exports.MessageCountResponse = exports.MessageCount = exports.QueryMessage = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
const direct_attachment_1 = require("./direct-attachment");
const flags_1 = require("./flags");
const handlers_1 = require("./handlers");
exports.QueryMessage = typebox_1.Type.Intersect([
    common_1.BaseQuery,
    typebox_1.Type.Partial(typebox_1.Type.Object({
        referenceEntityType: common_1.EntityType,
        referenceId: typebox_1.Type.String({ format: 'uuid' }),
        topic: typebox_1.Type.String(),
        deleted: typebox_1.Type.Boolean({ default: false }),
    })),
]);
exports.MessageCount = typebox_1.Type.Object({
    date: typebox_1.Type.String({ format: 'date' }),
    count: typebox_1.Type.Integer(),
});
exports.MessageCountResponse = typebox_1.Type.Object({
    totalCount: typebox_1.Type.Integer(),
    dailyCounts: typebox_1.Type.Array(exports.MessageCount),
});
exports.QueryMessageCount = typebox_1.Type.Object({
    startDate: typebox_1.Type.String({ format: 'date' }),
    endDate: typebox_1.Type.String({ format: 'date' }),
    handler: typebox_1.Type.Optional(handlers_1.Handler),
});
exports.Message = typebox_1.Type.Object({
    id: typebox_1.Type.String(),
    handler: handlers_1.Handler,
    template: typebox_1.Type.Optional(typebox_1.Type.String()),
    sendAs: typebox_1.Type.Optional(typebox_1.Type.String()),
    destination: typebox_1.Type.String(),
    title: typebox_1.Type.String(),
    body: typebox_1.Type.String(),
    sendAfter: typebox_1.Type.String({ format: 'date-time' }),
    sentAt: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date-time' })),
    sendingProfileID: typebox_1.Type.String(),
    sendingHaulerID: typebox_1.Type.String(),
    sendErrors: typebox_1.Type.Array(typebox_1.Type.String()),
    needsRetry: typebox_1.Type.Boolean(),
    notifySenderOnFail: typebox_1.Type.Boolean(),
    fatallyFailed: typebox_1.Type.Boolean(),
    topic: typebox_1.Type.String(),
    directAttachments: typebox_1.Type.Array(direct_attachment_1.DirectAttachment),
    attachmentS3ItemRefs: typebox_1.Type.Array(common_1.S3ItemReference),
    flags: typebox_1.Type.Optional(typebox_1.Type.Array(flags_1.NotificationFlag)),
    references: typebox_1.Type.Array(common_1.EntityReference),
    deleted: typebox_1.Type.Boolean(),
});
//# sourceMappingURL=message.js.map